import { AxiosService } from './axiosService';

export class DistributorService extends AxiosService {
    async getDistributorById(id) {
        try {
            const { data } = await this.axios.get(`/distributors/${id}`, {
                params: {
                    distributorId: id,
                },
            });
            return data;
        } catch (e) {
            // if the status code is a 401 we do NOT want to throw
            if (e?.response?.status !== 401) {
                throw e;
            }
        }
        return null;
    }

    async getDistributors(pageSize, pageIndex, sortField, sortDirection) {
        try {
            const { data } = await this.axios.get('/distributors', {
                params: {
                    pageSize: pageSize,
                    pageIndex: pageIndex,
                    sortBy: sortField,
                    orderBy: sortDirection
                },
            });
            return data;
        } catch (e) {
            // if the status code is a 401 we do NOT want to throw
            if (e?.response?.status !== 401) {
                throw e;
            }
        }
        return null;
    }

    async putSettings(stripeKey) {
        try {
            const { data } = await this.axios.put('/distributors/settings', {
                stripeApiKey: stripeKey,
            });
            return data;
        } catch (e) {
            // if the status code is a 401 we do NOT want to throw
            if (e?.response?.status !== 401) {
                throw e;
            }
        }
        return null;
    }

    async putDistributor(id, name, notes, address, city, state, zip, pricingMultiplier) {
        try {
            const { data } = await this.axios.put('/distributors', {
                id: id,
                name: name,
                notes: notes,
                address: address,
                city: city,
                state: state,
                zip: zip,
                pricingMultiplier
            });
            return data;
        } catch (e) {
            // if the status code is a 401 we do NOT want to throw
            if (e?.response?.status !== 401) {
                throw e;
            }
        }
        return null;
    }

    async postDistributor(name, notes, address, city, state, zip, pricingMultiplier) {
        try {
            const { data } = await this.axios.post('/distributors', {
                name: name,
                notes: notes,
                address: address,
                city: city,
                state: state,
                zip: zip,
                pricingMultiplier
            });
            return data;
        } catch (e) {
            // if the status code is a 401 we do NOT want to throw
            if (e?.response?.status !== 401) {
                throw e;
            }
        }
        return null;
    }

    async uploadLogo(distributorId, fileName, image) {
        const formData = new FormData();
        formData.append('distributorId', distributorId);
        formData.append('image', image);
        formData.append('fileName', fileName);
        try {
            const { data } = await this.axios.post('/distributors/uploadLogo', formData);
            return data;
        } catch (e) {
            // if the status code is a 401 we do NOT want to throw
            if (e?.response?.status !== 401) {
                throw e;
            }
        }
        return null;
    }

    async deleteDistributor(id) {
        try {
            const { data } = await this.axios.delete('/distributors', {
                data: {
                    id
                }
            });
            return data;
        } catch (e) {
            // if the status code is a 401 we do NOT want to throw
            if (e?.response?.status !== 401) {
                throw e;
            }
        }
        return null;
    }

    async checkStripeConnectAccount(id) {
        try {
            const { data } = await this.axios.get('/distributors/stripe-connect-account-check', {
                params: {
                    distributorId: id
                }
            });
            return data;
        } catch (e) {
            // if the status code is a 401 we do NOT want to throw
            if (e?.response?.status !== 401) {
                throw e;
            }
        }
        return null;
    }

    async manageStripeConnectAccount(id) {
        try {
            const { data } = await this.axios.put('/distributors/stripe-connect-account', {
                id
            });
            return data;
        } catch (e) {
            // if the status code is a 401 we do NOT want to throw
            if (e?.response?.status !== 401) {
                throw e;
            }
        }
        return null;
    }
}

export const distributorService = new DistributorService();
